import axios from 'axios';

import { URL_CONSTANTS } from '../../../../constants/urlConstants';
export const saveTableConfiguration = async body => {
  try {
    const res = await axios.post(
      `${URL_CONSTANTS?.API?.BASE_URL}/table-configuration`,
      body
    );
    return res || {};
  } catch (e) {
    console.error(
      'table.configuration.service',
      'saveTableConfiguration',
      e && e.message ? e.message : e
    );
    return {};
  }
};

export const getTableConfiguration = async tableKey => {
  try {
    const res = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/table-configuration`,
      {
        params: { table_key: tableKey },
      }
    );

    return res?.data || {};
  } catch (e) {
    console.error('getTableConfiguration', e);
    return {};
  }
};

/** GET body is usually { status, data: { column_configuration } } */
export function parseTablePinConfigFromApiResponse(res) {
  const configStr =
    res?.data?.column_configuration ?? res?.column_configuration;
  if (!configStr || typeof configStr !== 'string') {
    return { fixHeader: false, frozenLeft: [] };
  }
  try {
    const config = JSON.parse(configStr);
    const frozenLeft = Array.isArray(config.frozenLeft ?? config.freezeleft)
      ? (config.frozenLeft ?? config.freezeleft)
      : [];
    const fixHeader =
      typeof (config.fixHeader ?? config.fixheader) === 'boolean'
        ? (config.fixHeader ?? config.fixheader)
        : false;
    return { fixHeader, frozenLeft };
  } catch {
    return { fixHeader: false, frozenLeft: [] };
  }
}

export function parseTablePinConfigFromSavePayload(payload) {
  try {
    const config = payload?.column_configuration
      ? JSON.parse(payload.column_configuration)
      : {};
    const frozenLeft = Array.isArray(config.frozenLeft ?? config.freezeleft)
      ? (config.frozenLeft ?? config.freezeleft)
      : [];
    const fixHeader =
      typeof (config.fixHeader ?? config.fixheader) === 'boolean'
        ? (config.fixHeader ?? config.fixheader)
        : false;
    return { fixHeader, frozenLeft };
  } catch {
    return { fixHeader: false, frozenLeft: [] };
  }
}
